import Vue from "vue";

/**
 * Bootstarp Vue 组件
 * How to use:
 * see https://bootstrap-vue.js.org/docs/components/alert
 */
import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.use(BootstrapVue);
